import React from 'react';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import ExecuteSider from './ExecuteSider';
import QAFilter from './QAFilter';
import QACreateModal from './QACreateModal';
import { Table, Popconfirm, message } from 'antd';
import moment from 'moment';

class QA extends React.Component {
    state = {
        loading: false,
        dataList: [],
        reply: false,
        sortParams: '',
        typeList: [],
        pagination: {
            current: 1,
            pageSize: 15,
        },
        dataList: [],
        searchArray: {},
        dateFormat: 'YYYY-MM-DD'
    }

    componentDidMount() {
        this.getTypeInfo();
        this.loadData();
        this.queryInvestigationStageByInvId();
    }

    loadData = (params) => {
        const { reply } = this.state;
        this.setState({ loading: true });
        const options = {
            url: reply ? API_URL.execute.listQuestionReplyed : API_URL.execute.listQuestionNotReply,
            data: { ...params },
            dataType: 'json',
            doneResult: (data => {
                const pagination = { ...this.state.pagination };
                pagination.total = data.totalCount;
                this.setState({
                    loading: false,
                    dataList: data.datas,
                    pagination,
                });
            }),
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { reply } = this.state;
        const { curRole, userId } = sessionStorage;
        const columnNames = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
        }, {
            title: '提问日期',
            dataIndex: 'questionDate',
            key: 'questionDate',
            sorter: true,
            sortType: 'common',
        }, {
            title: '提问人员',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            sorter: true,
            sortType: 'common',
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
            sortType: 'common',
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
            sortType: 'common',
        }, {
            title: '问题分类',
            dataIndex: 'questionCategoryName',
            key: 'questionCategoryName',
            sorter: true,
            sortType: 'common',
        }, {
            title: '问题概述',
            dataIndex: 'questionOverview',
            key: 'questionOverview',
            sorter: true,
        }];
        reply && columnNames.push({
            title: '回复人员',
            dataIndex: 'answerUserCompellation',
            key: 'answerUserCompellation',
            sorter: true,
        }, {
            title: '回复日期',
            dataIndex: 'answerDate',
            key: 'answerDate',
            sorter: true,
        });

        columnNames.push({
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 130,
            render: (text, record) => {
                const { questionLogId, questionUserId } = record;
                if (curRole == "CRC") {
                    if (!reply) {
                        if (questionUserId == userId) {
                            return (
                                <span>
                                    <a onClick={() => this.showQAModal(questionLogId, 'view')}>查看</a>
                                    <span className="ant-divider" />
                                    <a onClick={() => this.canEditByInvStatus(() => this.showQAModal(questionLogId, 'edit'))}>修改</a>
                                    <span className="ant-divider" />
                                    <Popconfirm title='确定要删除吗?' onConfirm={() => this.canEditByInvStatus(() => this.handleDel(questionLogId))} okText="确定" cancelText="取消">
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                            );
                        } else {
                            return <a onClick={() => this.showQAModal(questionLogId, 'view')}>查看</a>;
                        }
                    } else {
                        return <a onClick={() => this.showQAModal(questionLogId, 'view')}>查看</a>;
                    }
                } else if (curRole == "PM" || curRole == "PA") {
                    return (
                        <span>
                            <a onClick={() => this.canEditByInvStatus(() => this.showQAModal(questionLogId, !reply ? 'reply' : 'view'))}>{!reply ? '回复' : '查看'}</a>
                            <span className="ant-divider" />
                            <a onClick={() => this.canEditByInvStatus(() => this.showQAModal(questionLogId, !reply ? 'edit' : 'editPM'))}>修改</a>
                            <span className="ant-divider" />
                            <Popconfirm title='确定要删除吗?' onConfirm={() => this.canEditByInvStatus(() => this.handleDel(questionLogId))} okText="确定" cancelText="取消">
                                <a>删除</a>
                            </Popconfirm>
                        </span>
                    );
                } else {
                    return <a onClick={() => this.showQAModal(questionLogId, 'view')}>查看</a>;
                }
            },
        });
        return columnNames;
    };

    getDataSource = () => {
        const records = [];
        const { dataList, pagination, dateFormat } = this.state;
        dataList.map((dataItem, i) => {
            if (dataItem.answerLog) {
                dataItem['answerUserCompellation'] = dataItem.answerLog.userCompellation;
                dataItem['answerDate'] = moment(dataItem.answerLog.answerDate).format(dateFormat);
            }
            records.push({
                key: dataItem.questionCategoryId,
                ...dataItem,
                index: ((pagination.current - 1) || 0) * 15 + i + 1,
                questionDate: moment(dataItem.questionDate).format(dateFormat)
            });
        });
        return records;
    };

    loadWaitingData = () => {
        if (this.state.reply == true) {
            this.setState({
                reply: false
            }, () => {
                this.loadData();
            })
        } else {
            this.setState({ reply: false })
        }
    }

    loadReplyedData = () => {
        if (this.state.reply == false) {
            this.setState({
                reply: true
            }, () => {
                this.loadData();
            })
        } else {
            this.setState({ reply: true })
        }
    }

    showQAModal = (id, mode) => {
        this.createModalRef.show(id, mode);
    }

    handleDel = (questionLogId) => {
        const options = {
            url: `${API_URL.execute.deleteQuestion}`,
            data: { questionLogId },
            dataType: 'json',
            doneResult: () => {
                this.loadData();
            },
        };
        $.sendRequest(options);
    }

    getTypeInfo = () => {
        const options = {
            method: 'POST',
            url: `${API_URL.execute.listQuestionCategory}`,
            doneResult: data => {
                this.setState({
                    typeList: data.datas,
                });
            }
        };
        $.sendRequest(options);
    }

    reset = (params = {}) => {
        this.setState({
            pagination: params.pagination,
        }, () => {
            this.loadData();
        })
    }

    reload = (params = {}) => {
        let pagination = this.state.pagination;
        if (params.pagination) {
            pagination = { ...this.state.pagination, ...params.pagination }
        }
        this.setState({
            searchArray: params,
            pagination,
        }, () => {
            this.loadData(params);
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        this.loadData({
            ...this.state.searchArray,
            offset: pagination.current,
            limit: pagination.pageSize,
            sort: sorter.field,
            direction: sorter.order == 'descend' ? 'DESC' : 'ASC',
        });
    }

    render() {
        const { reply, sortParams, typeList, loading, pagination } = this.state;
        const waitingTab = <a onClick={this.loadWaitingData} className={!reply ? "curr" : ""} >待回复</a>;
        const replyedTab = <a onClick={this.loadReplyedData} className={reply ? "curr" : ""} >已回复</a>;
        return (
            <div className="content">
                <ExecuteSider selectKey='QA' ref={el => { this.siderRef = el; }} />
                <div className="main">
                    <div>
                        <div className="tab_flex">
                            {waitingTab}
                            {replyedTab}
                        </div>
                    </div>
                    <QAFilter
                        canEditByInvStatus={this.canEditByInvStatus}
                        showCreateModal={this.showQAModal}
                        sortParams={sortParams}
                        reload={this.reload}
                        reset={this.reset}
                        reply={reply}
                        typeList={typeList}
                    />
                    <div className="content">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.id}
                            loading={loading}
                            onChange={this.handleTableChange}
                            pagination={pagination}
                            scroll={{ x: 1500 }}
                        />
                    </div>
                </div>
                <QACreateModal
                    ref={el => this.createModalRef = el}
                    reload={this.reload}
                    reply={reply}
                />
            </div>
        );
    }
}

export default QA;



// WEBPACK FOOTER //
// ./src/components/execute/QA.js